import styled from 'styled-components';

import { Textarea } from '@dreryk/react-components';

export const StyledNoteModalTextArea = styled(Textarea)`
   min-height: 150px;
`;

StyledNoteModalTextArea.displayName = 'StyledNoteModalTextArea';
